import JobPostings from './JobPostings'
export default JobPostings
